// Static product data - works without backend
export const PRODUCTS = [
  {
    id: "prod-001",
    name: "Artisan Ceramic Vase",
    description: "Handcrafted ceramic vase with a modern organic shape. Perfect for fresh flowers or as a standalone decorative piece. Each vase is unique due to the artisan process.",
    price: 89.99,
    original_price: 119.99,
    category: "Vases & Planters",
    images: ["https://images.unsplash.com/photo-1612871177858-b5defed7c67c?w=800"],
    rating: 4.8,
    reviews_count: 124,
    featured: true,
    best_seller: true,
    new_arrival: false,
    colors: ["White", "Beige", "Terracotta"],
    materials: ["Ceramic"],
    dimensions: "12\" H x 6\" W",
    specifications: { Weight: "2.5 lbs", Care: "Wipe clean with damp cloth" }
  },
  {
    id: "prod-002",
    name: "Modern Table Lamp",
    description: "Elegant table lamp with a sleek metal base and linen shade. Provides warm ambient lighting perfect for living rooms and bedrooms.",
    price: 149.99,
    original_price: null,
    category: "Decorative Lamps",
    images: ["https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=800"],
    rating: 4.7,
    reviews_count: 89,
    featured: true,
    best_seller: true,
    new_arrival: false,
    colors: ["Brass", "Black", "Chrome"],
    materials: ["Metal", "Linen"],
    dimensions: "18\" H x 10\" W",
    specifications: { "Bulb Type": "E26 LED (included)", Wattage: "40W max" }
  },
  {
    id: "prod-003",
    name: "Velvet Throw Pillow Set",
    description: "Luxurious velvet throw pillows with hidden zipper. Set of 2 pillows in complementary colors. Includes removable covers.",
    price: 69.99,
    original_price: 89.99,
    category: "Throw Pillows",
    images: ["https://images.unsplash.com/photo-1629949009765-40fc74c9ec21?w=800"],
    rating: 4.9,
    reviews_count: 256,
    featured: true,
    best_seller: true,
    new_arrival: true,
    colors: ["Sage Green", "Dusty Rose", "Navy", "Mustard"],
    materials: ["Velvet", "Cotton"],
    dimensions: "18\" x 18\"",
    specifications: { Fill: "Hypoallergenic polyester", Care: "Machine washable covers" }
  },
  {
    id: "prod-004",
    name: "Gold Frame Decorative Mirror",
    description: "Statement wall mirror with ornate gold frame. Adds elegance and dimension to any room. Includes mounting hardware.",
    price: 199.99,
    original_price: null,
    category: "Mirrors",
    images: ["https://images.unsplash.com/photo-1618220179428-22790b461013?w=800"],
    rating: 4.6,
    reviews_count: 67,
    featured: true,
    best_seller: false,
    new_arrival: false,
    colors: ["Gold", "Silver", "Bronze"],
    materials: ["Glass", "Wood", "Metal Leaf"],
    dimensions: "36\" H x 24\" W",
    specifications: { Weight: "15 lbs", Mounting: "D-ring hangers included" }
  },
  {
    id: "prod-005",
    name: "Sculptural Table Decor",
    description: "Abstract sculptural piece perfect for coffee tables, shelves, or mantels. Modern minimalist design in matte finish.",
    price: 79.99,
    original_price: null,
    category: "Table Decor",
    images: ["https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800"],
    rating: 4.5,
    reviews_count: 43,
    featured: false,
    best_seller: false,
    new_arrival: true,
    colors: ["White", "Black", "Stone Gray"],
    materials: ["Resin"],
    dimensions: "8\" H x 5\" W",
    specifications: { Finish: "Matte", Base: "Felt-lined" }
  },
  {
    id: "prod-006",
    name: "Luxury Scented Candle Set",
    description: "Premium soy wax candles with essential oil blends. Set of 3 complementary scents in elegant glass jars. 45-hour burn time each.",
    price: 59.99,
    original_price: 74.99,
    category: "Home Fragrances",
    images: ["https://images.unsplash.com/photo-1602028915047-37269d1a73f7?w=800"],
    rating: 4.8,
    reviews_count: 312,
    featured: false,
    best_seller: true,
    new_arrival: false,
    colors: [],
    materials: ["Soy Wax", "Essential Oils", "Cotton Wick"],
    dimensions: "3.5\" H x 3\" W each",
    specifications: { Scents: "Vanilla Bean, Lavender Fields, Ocean Breeze", "Burn Time": "45 hours each" }
  },
  {
    id: "prod-007",
    name: "Abstract Canvas Wall Art",
    description: "Museum-quality canvas print featuring abstract contemporary art. Stretched over wooden frame, ready to hang.",
    price: 179.99,
    original_price: null,
    category: "Wall Art",
    images: ["https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=800"],
    rating: 4.7,
    reviews_count: 156,
    featured: true,
    best_seller: false,
    new_arrival: false,
    colors: ["Neutral Tones", "Blue Abstract", "Earth Tones"],
    materials: ["Canvas", "Wood Frame"],
    dimensions: "36\" x 24\"",
    specifications: { Depth: "1.5\"", Hanging: "Wire hanger included" }
  },
  {
    id: "prod-008",
    name: "Ceramic Planter Set",
    description: "Set of 3 modern ceramic planters with drainage holes and matching saucers. Perfect for succulents and small plants.",
    price: 54.99,
    original_price: null,
    category: "Vases & Planters",
    images: ["https://images.unsplash.com/photo-1485955900006-10f4d324d411?w=800"],
    rating: 4.6,
    reviews_count: 89,
    featured: false,
    best_seller: false,
    new_arrival: true,
    colors: ["White", "Terracotta", "Sage"],
    materials: ["Ceramic"],
    dimensions: "4\", 5\", 6\" diameter",
    specifications: { Includes: "Drainage holes and saucers" }
  },
  {
    id: "prod-009",
    name: "Pendant Light Fixture",
    description: "Modern pendant light with adjustable height. Features a minimalist dome shade in premium metal finish.",
    price: 189.99,
    original_price: 229.99,
    category: "Decorative Lamps",
    images: ["https://images.unsplash.com/photo-1524484485831-a92ffc0de03f?w=800"],
    rating: 4.8,
    reviews_count: 78,
    featured: true,
    best_seller: false,
    new_arrival: false,
    colors: ["Matte Black", "Brass", "White"],
    materials: ["Metal", "Glass"],
    dimensions: "12\" diameter",
    specifications: { "Cord Length": "Adjustable up to 60\"", Bulb: "E26 (not included)" }
  },
  {
    id: "prod-010",
    name: "Decorative Throw Blanket",
    description: "Cozy knitted throw blanket with decorative fringe. Perfect for sofas, beds, or chairs. Machine washable.",
    price: 79.99,
    original_price: null,
    category: "Throw Pillows",
    images: ["https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800"],
    rating: 4.9,
    reviews_count: 203,
    featured: false,
    best_seller: true,
    new_arrival: false,
    colors: ["Cream", "Gray", "Blush", "Navy"],
    materials: ["Cotton", "Acrylic"],
    dimensions: "50\" x 60\"",
    specifications: { Care: "Machine wash cold, tumble dry low" }
  },
  {
    id: "prod-011",
    name: "Marble Bookends Set",
    description: "Sophisticated marble bookends with geometric design. Heavy enough to support your book collection with style.",
    price: 69.99,
    original_price: null,
    category: "Table Decor",
    images: ["https://images.unsplash.com/photo-1544457070-4cd773b4d71e?w=800"],
    rating: 4.5,
    reviews_count: 45,
    featured: false,
    best_seller: false,
    new_arrival: false,
    colors: ["White Marble", "Black Marble", "Green Marble"],
    materials: ["Natural Marble"],
    dimensions: "6\" H x 4\" W x 4\" D each",
    specifications: { Weight: "3 lbs per bookend", Includes: "Felt pads" }
  },
  {
    id: "prod-012",
    name: "Reed Diffuser Collection",
    description: "Long-lasting reed diffuser set with natural rattan sticks. Provides continuous fragrance for up to 3 months.",
    price: 44.99,
    original_price: null,
    category: "Home Fragrances",
    images: ["https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?w=800"],
    rating: 4.6,
    reviews_count: 167,
    featured: false,
    best_seller: false,
    new_arrival: true,
    colors: [],
    materials: ["Essential Oils", "Rattan"],
    dimensions: "8\" bottle height",
    specifications: { Scents: "White Tea, Eucalyptus, Sandalwood", Duration: "Up to 3 months" }
  },
  {
    id: "prod-013",
    name: "Woven Wall Basket Set",
    description: "Set of 3 handwoven decorative wall baskets. Perfect for creating a bohemian gallery wall. Each basket has unique patterns.",
    price: 89.99,
    original_price: 109.99,
    category: "Wall Art",
    images: ["https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800"],
    rating: 4.7,
    reviews_count: 134,
    featured: true,
    best_seller: true,
    new_arrival: false,
    colors: ["Natural", "Black & White", "Terracotta"],
    materials: ["Seagrass", "Rattan"],
    dimensions: "12\", 14\", 16\" diameter",
    specifications: { Mounting: "Nail or command strip", Style: "Bohemian" }
  },
  {
    id: "prod-014",
    name: "Crystal Table Lamp",
    description: "Elegant crystal table lamp with fabric drum shade. Creates beautiful light patterns. Perfect for bedside or accent lighting.",
    price: 159.99,
    original_price: null,
    category: "Decorative Lamps",
    images: ["https://images.unsplash.com/photo-1540932239986-30128078f3c5?w=800"],
    rating: 4.8,
    reviews_count: 92,
    featured: true,
    best_seller: false,
    new_arrival: false,
    colors: ["Crystal Clear", "Smoke Gray"],
    materials: ["Crystal", "Metal", "Fabric"],
    dimensions: "22\" H x 12\" W",
    specifications: { "Bulb Type": "E26 60W max", Switch: "3-way rotary" }
  },
  {
    id: "prod-015",
    name: "Macrame Plant Hanger Set",
    description: "Set of 3 handcrafted macrame plant hangers in varying lengths. Adds texture and greenery to any space.",
    price: 39.99,
    original_price: null,
    category: "Vases & Planters",
    images: ["https://images.unsplash.com/photo-1622398925373-3f91b1e275f5?w=800"],
    rating: 4.6,
    reviews_count: 178,
    featured: false,
    best_seller: true,
    new_arrival: true,
    colors: ["Natural Cotton", "Black", "Sage Green"],
    materials: ["100% Cotton Cord"],
    dimensions: "24\", 32\", 40\" length",
    specifications: { "Weight Capacity": "Up to 10 lbs", "Pot Size": "4-8\" diameter" }
  },
  {
    id: "prod-016",
    name: "Decorative Tray Set",
    description: "Set of 2 nesting decorative trays with handles. Perfect for coffee table styling, serving, or organizing.",
    price: 64.99,
    original_price: null,
    category: "Table Decor",
    images: ["https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=800"],
    rating: 4.5,
    reviews_count: 86,
    featured: false,
    best_seller: false,
    new_arrival: false,
    colors: ["Brass", "Silver", "Rose Gold"],
    materials: ["Metal", "Mirror Glass"],
    dimensions: "12\" x 8\" and 14\" x 10\"",
    specifications: { Base: "Non-scratch felt pads", Handles: "Built-in handles" }
  },
  {
    id: "prod-017",
    name: "Botanical Print Set",
    description: "Set of 4 botanical art prints in elegant frames. Features vintage-style botanical illustrations. Ready to hang.",
    price: 129.99,
    original_price: 159.99,
    category: "Wall Art",
    images: ["https://images.unsplash.com/photo-1513519245088-0e12902e5a38?w=800"],
    rating: 4.8,
    reviews_count: 201,
    featured: true,
    best_seller: true,
    new_arrival: false,
    colors: ["Black Frame", "Gold Frame", "White Frame"],
    materials: ["Premium Paper", "Wood Frame", "Glass"],
    dimensions: "11\" x 14\" each",
    specifications: { Printing: "Archival quality", Hanging: "Sawtooth hangers included" }
  },
  {
    id: "prod-018",
    name: "Aromatherapy Oil Diffuser",
    description: "Ultrasonic essential oil diffuser with wood grain finish. Features 7 LED color options and auto shut-off.",
    price: 49.99,
    original_price: null,
    category: "Home Fragrances",
    images: ["https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?w=800"],
    rating: 4.7,
    reviews_count: 289,
    featured: false,
    best_seller: true,
    new_arrival: true,
    colors: ["Light Wood", "Dark Wood", "White"],
    materials: ["BPA-Free Plastic", "Wood Grain Finish"],
    dimensions: "6\" H x 4\" diameter",
    specifications: { "Tank Capacity": "300ml", "Run Time": "Up to 10 hours", Coverage: "300 sq ft" }
  },
  {
    id: "prod-019",
    name: "Geometric Terrarium",
    description: "Modern geometric glass terrarium for air plants, succulents, or candles. Features brass-colored metal frame.",
    price: 34.99,
    original_price: null,
    category: "Vases & Planters",
    images: ["https://images.unsplash.com/photo-1446071103084-c257b5f70672?w=800"],
    rating: 4.6,
    reviews_count: 112,
    featured: false,
    best_seller: false,
    new_arrival: true,
    colors: ["Gold", "Black", "Copper"],
    materials: ["Glass", "Metal"],
    dimensions: "6\" H x 5\" W",
    specifications: { Style: "Geometric Pentagon", Opening: "Hinged door" }
  },
  {
    id: "prod-020",
    name: "Faux Olive Tree",
    description: "Realistic artificial olive tree in decorative pot. Maintenance-free greenery that looks stunning year-round.",
    price: 149.99,
    original_price: 189.99,
    category: "Vases & Planters",
    images: ["https://images.unsplash.com/photo-1459411552884-841db9b3cc2a?w=800"],
    rating: 4.9,
    reviews_count: 324,
    featured: true,
    best_seller: true,
    new_arrival: false,
    colors: ["Green"],
    materials: ["Silk Leaves", "Plastic Stem", "Cement Pot"],
    dimensions: "5 ft tall",
    specifications: { Pot: "7\" diameter cement pot", Care: "Dust with soft cloth" }
  }
];

// Get all categories
export const CATEGORIES = [...new Set(PRODUCTS.map(p => p.category))];

// Filter functions
export const getBestSellers = () => PRODUCTS.filter(p => p.best_seller);
export const getNewArrivals = () => PRODUCTS.filter(p => p.new_arrival);
export const getFeatured = () => PRODUCTS.filter(p => p.featured);
export const getByCategory = (category) => PRODUCTS.filter(p => p.category === category);
export const getProductById = (id) => PRODUCTS.find(p => p.id === id);

// Sample reviews
export const REVIEWS = [
  { id: "rev-001", product_id: "prod-001", customer_name: "Sarah M.", rating: 5, comment: "Absolutely stunning vase! It looks even better in person. The quality is exceptional." },
  { id: "rev-002", product_id: "prod-001", customer_name: "Michael R.", rating: 5, comment: "Perfect addition to my living room. The craftsmanship is beautiful." },
  { id: "rev-003", product_id: "prod-002", customer_name: "Emily K.", rating: 5, comment: "This lamp is gorgeous! The light it gives off is warm and inviting." },
  { id: "rev-004", product_id: "prod-003", customer_name: "Jennifer L.", rating: 5, comment: "These pillows are so soft and luxurious. The colors are exactly as pictured." },
  { id: "rev-005", product_id: "prod-006", customer_name: "David W.", rating: 5, comment: "Best candles I've ever bought. The scents are amazing and long-lasting." },
];

export const getReviewsByProductId = (productId) => REVIEWS.filter(r => r.product_id === productId);
